import { useFakeStakeholderMapStore } from './FakeStakeholderMapStore';
import { useStakeholderMapStore } from './StakeholderMapStore';
import { stakeholderMapRequest, StakeholderMapRequest } from '../services/StakeholderMapRequest';

/**
 * Factory function that returns the appropriate store based on the environment.
 * Supports dependency injection for testing by accepting an optional request instance.
 * @param requestInstance - Optional StakeholderMapRequest instance for dependency injection
 */
export const createStakeholderMapStore = (requestInstance?: StakeholderMapRequest) => {
  const isDevelopment = import.meta.env.MODE === 'development';
  const useDevApi = import.meta.env.VITE_USE_DEV_API === 'true';

  if (!isDevelopment || useDevApi) {
    // Use provided instance or default singleton
    const request = requestInstance || stakeholderMapRequest;
    return useStakeholderMapStore(request)();
  } else {
    return useFakeStakeholderMapStore();
  }
};

// Export the factory as the default export for easy importing
export default createStakeholderMapStore;
